import { ModuleData } from '../types'

export const MODULES: ModuleData[] = [
  {
    id: 'Metriek',
    title: 'Metriek & Meetkunde',
    description:
      'Omrekenen (mm, cm, dm, m, km), oppervlakte berekenen, inhoud en volume.',
    icon: 'Ruler',
    color: 'text-blue-500',
  },
  {
    id: 'Getalbegrip',
    title: 'Getalbegrip & Breuken',
    description:
      'Grote getallen lezen en schrijven, breuken vereenvoudigen, kommagetallen, kolomsgewijs aftrekken.',
    icon: 'Calculator',
    color: 'text-indigo-500',
  },
  {
    id: 'TijdGeld',
    title: 'Tijd & Geld',
    description:
      'Klokkijken tot op de seconde (analoog en digitaal), tijdsduur berekenen, rekenen met euro en centen.',
    icon: 'Clock',
    color: 'text-emerald-500',
  },
  {
    id: 'SpellingWW',
    title: 'Werkwoordspelling',
    description:
      "Stam bepalen, 't Kofschip regel, verleden tijd, voltooid deelwoord.",
    icon: 'PenTool',
    color: 'text-rose-500',
  },
  {
    id: 'SpellingRegel',
    title: 'Regelwoorden & Taal',
    description:
      'Lange en korte klanken, verdubbeling, trema, weetwoorden (café, cadeau).',
    icon: 'BookOpen',
    color: 'text-amber-500',
  },
  {
    id: 'Taalbegrip',
    title: 'Taalbegrip & Woordsoorten',
    description:
      'Bijvoeglijke naamwoorden herkennen en toepassen, woordsoorten onderscheiden.',
    icon: 'MessageSquare',
    color: 'text-purple-500',
  },
]
